export default __webpack_public_path__ + "96aabeec86d277690dccb1bb533820a6.png";